
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/specialists",
      function () {
        return require("private-next-pages/specialists.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/specialists"])
      });
    }
  